import {useState, useEffect, useRef, useCallback} from "react";
import MapComponent from "./RMap";
import {capitalizeFirstLetter, Filters} from '../../../../../utils/HelpFunctions';
import circle from '@turf/circle';
import * as turf from '@turf/turf';
import {point, polygon} from '@turf/helpers';
import Geocode from "react-geocode"
import PolyLine from '@mapbox/polyline';
import {lineString as makeLineString} from '@turf/helpers';

const {REACT_APP_GM_KEY} = process.env
Geocode.setApiKey(REACT_APP_GM_KEY);
Geocode.setLanguage("en");
Geocode.setRegion("es");

const options = {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 0,
};

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}


function MapReservationManual(props) {

    const {
        dataCoords, setShowBackBtn, setDataCoords, DataStore, setShowCalendar, setRestrict, showBounds, setShowBounds,
        viewport, setViewport, clickControl, showCalendar
    } = props;

    const {restrictZones} = DataStore;

    const [routes, setRoutes] = useState(null);
    const [origen, setOrigen] = useState(null);
    const [destination, setDestination] = useState(null);
    const [zoom, setZoom] = useState(16);
    const [restrictZoneOrigin, setRestrictZoneOrigin] = useState(null)
    const [restrictZoneDestination, setRestrictZoneDestination] = useState(null)

    const isMounted = useMountedState()

    /*Marker origen-destination*/
    useEffect(() => {
        if (isMounted()) {
            if (dataCoords) {
                setOrigen(dataCoords.origen);
                setDestination(dataCoords.destiny);
                setShowBounds(false)
                setZoom(16)
            }
        }

    }, [dataCoords, isMounted]);

    useEffect(() => {
        if (isMounted()) {
            if (dataCoords) {
                if (dataCoords.origen) {
                    setOrigen(dataCoords.origen);
                    const latitude = dataCoords.origen[0];
                    const longitude = dataCoords.origen[1];
                    const city = dataCoords.origenCity;
                    const capitalizeCity = capitalizeFirstLetter(city)
                    const filterZones = Filters(restrictZones, 'id', capitalizeCity)
                    filterZones.length > 0 && setRestrictZoneOrigin(filterZones[0].zoneList)
                    let countZones = 0;
                    setViewport({...viewport, latitude: latitude, longitude: longitude});
                    setZoom(16)
                    const zones = Filters(restrictZones, 'id', city);
                    if (zones.length > 0) {
                        Object.values(zones[0]['zoneList']).forEach(data => {
                            const center = [data.longitude, data.latitude];
                            const options = {
                                steps: 25,
                                units: 'kilometers',
                                options: {},
                            };
                            const restrictZone = circle(center, data.radius, options);
                            let pt = point([longitude, latitude]);
                            let poly = polygon(restrictZone.geometry.coordinates);

                            if (turf.booleanPointInPolygon(pt, poly)) {
                                countZones = countZones + 1;
                            }
                            if (countZones >= 1) {
                                setRestrict(true);
                                setShowCalendar(false);
                            } else {
                                setRestrict(false);
                            }
                        });
                    }
                }
            }
        }

    }, [origen, destination, isMounted]);

    useEffect(() => {
        if (isMounted()) {
            if (dataCoords) {
                if (dataCoords.destiny) {
                    let countZones = 0;
                    const latitude = dataCoords.destiny[0];
                    const longitude = dataCoords.destiny[1];
                    const city = dataCoords.destinyCity;
                    const capitalizeCity = capitalizeFirstLetter(city)
                    const filterZones = Filters(restrictZones, 'id', capitalizeCity)
                    filterZones.length > 0 && setRestrictZoneDestination(filterZones[0].zoneList)
                    setOrigen(dataCoords.origen);
                    setDestination(dataCoords.destiny);
                    setViewport({...viewport, latitude: latitude, longitude: longitude});
                    setZoom(16)
                    const zones = Filters(restrictZones, 'id', city);
                    if (zones.length > 0) {
                        Object.values(zones[0]['zoneList']).forEach(data => {
                            const center = [data.longitude, data.latitude];
                            const options = {
                                steps: 25,
                                units: 'kilometers',
                                options: {},
                            };
                            const restrictZone = circle(center, data.radius, options);
                            let pt = point([longitude, latitude]);
                            let poly = polygon(restrictZone.geometry.coordinates);

                            if (turf.booleanPointInPolygon(pt, poly)) {
                                countZones = countZones + 1;
                            }
                            if (countZones >= 1) {
                                setRestrict(true);
                                setShowCalendar(false);
                            } else {
                                setRestrict(false);
                            }
                        });
                    }

                }
            }
        }
    }, [destination, isMounted]);

    /*Paint route*/
    useEffect(() => {
        if (isMounted()) {
            if (origen && destination) {
                const lat_origen = origen[0];
                const lng_origen = origen[1];

                const lat_destination = destination[0];
                const lng_destination = destination[1];
                setShowBackBtn(false)

                const GetPoints = async () => {
                    const directionsService = new window.google.maps.DirectionsService();

                    const origin = {lat: lat_origen, lng: lng_origen};
                    const destination = {lat: lat_destination, lng: lng_destination};

                    setShowBackBtn(false)

                    const newArray = []

                    directionsService.route(
                        {
                            origin: origin,
                            destination: destination,
                            travelMode: window.google.maps.TravelMode.DRIVING,
                        },
                        (result, status) => {
                            if (status === window.google.maps.DirectionsStatus.OK) {
                                const points = PolyLine.decode(result.routes[0].overview_polyline);

                                const pointsCoords = points.map(point => {
                                    return [point[1], point[0]];
                                });
                                const lineStr = makeLineString(pointsCoords);
                                lineStr.geometry.coordinates.forEach(items => {
                                    const newObject = {lat: items[1], lng: items[0]};
                                    newArray.push(newObject)
                                })
                                setRoutes(newArray)
                            } else {
                                console.error(`error fetching directions ${result}`);
                            }
                        },
                    );
                };

                showCalendar &&  GetPoints().catch(() => {
                });
            }
        }

    }, [origen, destination, isMounted]);

    const UpdateOrigenAddress = (addresses_0, addresses_1, lat, lng, response) => {
        if (addresses_1.length <= 2) {
            setDataCoords({
                ...dataCoords,
                origen: [lat, lng],
                origenDirection: response.results[0].formatted_address
            })
        }
        if (addresses_0.length > 2 && addresses_1.length > 2) {
            setDataCoords({
                ...dataCoords,
                origen: [lat, lng],
                origenDirection: response.results[1].formatted_address
            })
        }
    }

    const onDragOrigen = async (lat, lng) => {
        setOrigen([lat, lng]);
        await Geocode.fromLatLng(lat.toString(), lng.toString())
            .then(response => {
                setOrigen([lat, lng]);
                const addresses_0 = response.results[0].formatted_address.split(' ');
                const addresses_1 = response.results[1].formatted_address.split(' ');
                UpdateOrigenAddress(addresses_0, addresses_1, lat, lng, response)
            })
    };

    const UpdateDestinationAddress = (addresses_0, addresses_1, lat, lng, response) => {
        if (addresses_1.length <= 2) {
            setDataCoords({
                ...dataCoords,
                destiny: [lat, lng],
                destinationDirection: response.results[0].formatted_address
            })
        }
        if (addresses_0.length > 2 && addresses_1.length > 2) {
            setDataCoords({
                ...dataCoords,
                destiny: [lat, lng],
                destinationDirection: response.results[1].formatted_address
            })
        }
    }

    const onDragDestination = async (lat, lng) => {
        setDestination([lat, lng]);
        await Geocode.fromLatLng(lat.toString(), lng.toString())
            .then(response => {
                const addresses_0 = response.results[0].formatted_address.split(' ');
                const addresses_1 = response.results[1].formatted_address.split(' ');
                UpdateDestinationAddress(addresses_0, addresses_1, lat, lng, response)
            })
    };

    const mapClicked = (lat, lng) => {
        if (origen && clickControl) {
            Geocode.fromLatLng(lat.toString(), lng.toString()).then(
                response => {
                    const address = response.results[0].formatted_address;
                    const origenCity = dataCoords.origenCity

                    const addresses_0 = response.results[0].formatted_address.split(' ');
                    const addresses_1 = response.results[1].formatted_address.split(' ');

                    const addressArray = BreakAddress(address.split(' '))

                    addressArray.forEach(city => {
                        let c = city.includes(",");
                        if (c) {
                            const data = city.replace(",", '')
                            if (data === origenCity) {
                                setOrigen([lat, lng]);
                                UpdateOrigenAddress(addresses_0, addresses_1, lat, lng, response)
                            }
                        } else {
                            const origenResult = addressArray.filter(city => city === origenCity)
                            if (origenResult.length > 0) {
                                setOrigen([lat, lng]);
                                UpdateOrigenAddress(addresses_0, addresses_1, lat, lng, response)
                            }
                        }
                    })
                })
        }

        if (destination && !clickControl) {
            Geocode.fromLatLng(lat.toString(), lng.toString()).then(
                response => {
                    const address = response.results[0].formatted_address;
                    const destinationCity = dataCoords.destinyCity

                    const addresses_0 = response.results[0].formatted_address.split(' ');
                    const addresses_1 = response.results[1].formatted_address.split(' ');

                    const addressArray = BreakAddress(address.split(' '))

                    addressArray.forEach(city => {

                        let c = city.includes(",");
                        if (c) {
                            const data = city.replace(",", '')
                            if (data === destinationCity) {
                                setDestination([lat, lng]);
                                UpdateDestinationAddress(addresses_0, addresses_1, lat, lng, response)
                            }

                        } else {
                            const destinationResult = addressArray.filter(city => city === destinationCity)
                            if (destinationResult.length > 0) {
                                setDestination([lat, lng]);
                                UpdateDestinationAddress(addresses_0, addresses_1, lat, lng, response)
                            }
                        }
                    })
                })
        }


        /* if (origen && destination) {
             Geocode.fromLatLng(lat.toString(), lng.toString()).then(
                 response => {
                     const address = response.results[0].formatted_address;
                     const origenCity = dataCoords.origenCity
                     const destinationCity = dataCoords.destinyCity

                     const addresses_0 = response.results[0].formatted_address.split(' ');
                     const addresses_1 = response.results[1].formatted_address.split(' ');

                     const addressArray = BreakAddress(address.split(' '))
                     addressArray.forEach(city => {
                         let c = city.includes(",");
                         if (c) {
                             const data = city.replace(",", '')
                             if (data === origenCity) {
                                 setOrigen([lat, lng]);
                                 UpdateOrigenAddress(addresses_0, addresses_1, lat, lng, response)
                             }
                             if (data === destinationCity) {
                                 setDestination([lat, lng]);
                                 UpdateDestinationAddress(addresses_0, addresses_1, lat, lng, response)
                             }

                         } else {
                             const origenResult = addressArray.filter(city => city === origenCity)
                             const destinationResult = addressArray.filter(city => city === destinationCity)
                             if (origenResult.length > 0) {
                                 setOrigen([lat, lng]);
                                 UpdateOrigenAddress(addresses_0, addresses_1, lat, lng, response)
                             }

                             if (destinationResult.length > 0) {
                                 setDestination([lat, lng]);
                                 UpdateDestinationAddress(addresses_0, addresses_1, lat, lng, response)
                             }

                         }
                     })

                 },
                 error => {
                    // console.error(error);
                 }
             );
         } else {
             alert('No se ha ingresado el origen o destino de el viaje')
         }
         setViewport({...viewport, latitude: lat, longitude: lng});*/
    }

    return (

        <div>
            <MapComponent
                center={{lat: viewport.latitude, lng: viewport.longitude}}
                origen={origen}
                destination={destination}
                zoom={zoom}
                onDragOrigen={onDragOrigen}
                onDragDestination={onDragDestination}
                routes={routes}
                mapClicked={mapClicked}
                dataCoords={dataCoords}
                restrictZoneOrigin={restrictZoneOrigin}
                restrictZoneDestination={restrictZoneDestination}
                showBounds={showBounds}
                setShowBounds={setShowBounds}
                setZoom={setZoom}
            />
        </div>
    )
}

export default MapReservationManual

const BreakAddress = (address) => {
    const dataAddress = []
    address.forEach(items => {
            dataAddress.push(items.split(' ')[0]);
        }
    )
    return dataAddress;
}
